import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export const WhatsAppFab = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={waLink("Hallo Global Move Europa, ich habe eine Frage per WhatsApp.")}
          target="_blank"
          rel="noreferrer"
          data-testid="floating-whatsapp-button"
          initial={{ opacity: 0, y: 24, scale: 0.85 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.85 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="group fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-[70] flex items-center gap-2 sm:gap-3 bg-[#25D366] hover:bg-[#1eb857] text-white h-12 sm:h-14 w-12 sm:w-auto justify-center sm:pl-4 sm:pr-5 rounded-full sm:rounded-none shadow-[0_10px_36px_rgba(37,211,102,0.4)] transition-colors"
          aria-label="Frage per WhatsApp"
        >
          <span className="relative grid place-items-center">
            <span className="absolute w-8 sm:w-9 h-8 sm:h-9 rounded-full bg-white/40 wa-ping" />
            <MessageCircle size={22} className="relative" />
          </span>
          <span className="hidden sm:inline font-display text-base font-bold uppercase tracking-wide whitespace-nowrap">
            Frage per WhatsApp
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};
